/**
 * Created by Qingger Corp.
 * User: 陈儒
 * Date: 2019/10/21
 * Time: 17:00
 * Desc:
 */

import { Component, Vue } from 'vue-property-decorator';
import type { ElForm } from 'element-ui/types/form';
import { groupBy, uniq } from 'lodash';
import { IPSService } from '@/services/ipsServices';
import { QinggerLibUtils, noop } from '@/util';
import { appEnvConfig } from '@/configs/appConfigs';
import { EmpServiceAPIActions } from '@/services/empService';
import baseAPIService from '@/services/base/baseAPIService';
import ChooseGoodsClass from '@/views/components/chooseGoodsClass';
import bindClassDialog from '@/views/components/newDisplayConfig/bindClassDialog';
import Upload from '@/views/components/upload/upload.vue';
import { Functions } from '@/library/utils/functions';
const isset = QinggerLibUtils.isset;

interface ProductAttrList {
  sgId?: number;
  list?: Array<{ valueCodes?: string[]; classSizePic?: string; attrCodes?: string[] }>;
  defaultPic?: string;
}

const AdminClassSizeService = ['getAdminClassSize', 'getAdminClassSize', 'getAdminClassSize', 'getAdminClassSize', 'getAdminClassSize'];

const AdminClassSizeSaveService = ['setAdminClassSizeSave', 'setAdminClassSizeSave', 'setAdminClassSizeSave', 'sitePicSave', 'setAdminClassSizeSave'];

@Component({
  components: {
    Upload,
  },
})
export default class sizeExplain extends Vue {
  /**
   * corpId
   */
  public corpId = baseAPIService.resolveCorpId();
  // 一級主档分类
  public classData: ProductAttrList = {};
  // 默认选中一级分类
  public selectValue = '';

  public classImageList: Array<{
    value_no: string;
    value_name: string;
    class_code: string;
    parent_no: string;
  }> = [];

  // 测试数据
  public imageUrl = '';

  // 尺码分类数据表
  public classSizeInfo: Array<any> = [];

  /**
   *  图片上传地址
   *  @type {string}
   */
  public imgTpConfig = `${Functions.ipsHostUrlApi()}/pic/upload/withOut/key`;

  /**
   * token
   * @type {{Authorization: string}}
   */
  public tokenData: ItemObject = {
    Authorization: `Bearer ${EmpServiceAPIActions.getTokenFromCache().token}`,
  };

  // 运营模式 1 镜单  2 镜千 3 云单 4 云千
  public mode = 0;

  // 网点分类列表
  public siteClassList = [];

  // 网点分类数据
  public siteClassData = {
    siteSizePic: '',
    siteSizeTable: [], // 网点尺码对照表
  };

  $refs: {
    sizeForm: ElForm;
  };

  rules = {
    siteSizePic: [{ required: true, message: ' ', trigger: 'change' }],
  };

  attributeListStore = [];

  /**
   * 当组建加载时
   */
  public async mounted() {
    const self = this;
    this.mode = Number(this.$route.params.mode);
    this.attributeListStore = await this.getLevelClassList();
    this.attributeListStore = this.computedTree(this.attributeListStore);
    self.getClassSizeInfo();
    // if (this.mode === 2 && Number(this.$route.params.siteId)) {
    //   this.siteClassList = await this.getSiteClassList();
    //   this.getSiteSizeTable();
    // } else {
    //   this.attributeListStore = await this.getLevelClassList();
    //   this.attributeListStore = this.computedTree(this.attributeListStore);
    //   self.getClassSizeInfo();
    // }
  }

  public computedClassName(classIds = []) {
    const classStore = this.siteClassList.flatMap(v => v.children || []);
    const classGroup = groupBy(
      classStore.filter(cs => classIds.includes(cs.classId)),
      'parentId',
    );
    const result = Object.keys(classGroup).map((v) => {
      const parentName = this.siteClassList.find(val => val.classId == v).className;
      const childrenClassName = classGroup[v].map(cg => cg.className).join('、');
      return `${parentName}/${childrenClassName}`;
    });
    return result.join(',');
  }

  /**
   * 获取层级列表
   * @return null
   */
  public getLevelClassList() {
    return IPSService.getAttributeList().then((res: ItemObject) => {
      return res.list;
    });
  }

  // 获取尺码分类数据表
  public getClassSizeInfo() {
    const self = this;
    const sgId = +this.$route.params.id || +this.$route.params.sgId;

    IPSService.classSizeGetNew({ postParams: { sgId } }).then((res: any) => {
      this.classData = res;
      // if (res && res.list) {
      //   self.classSizeInfo = res.list;
      //   self.selectValue = self.classSizeInfo[0] ? self.classSizeInfo[0].attrCode : "";

      //   this.classList.forEach((i) => {
      //     i.list.forEach((z) => {
      //       if (this.classSizeInfo.some((v) => z.class_code === v.class_code)) {
      //         this.selectValue = i.attrCode;
      //       }
      //     });
      //   });
      // }
    });
  }

  /**
   * @return null
   */
  public getLevelValueList(list): void {
    this.classSizeInfo = list.list;

    this.classSizeInfo = this.classSizeInfo.map((item) => {
      item.imageUrl = [];
      return item;
    });
  }

  public onSubmit() {
    this.$refs.sizeForm.validate((result) => {
      if (result) {
        IPSService.classSizeSaveNew({
          postParams: {
            sgId: Number(this.$route.params.id) || Number(this.$route.params.sgId),
            defaultPic: this.classData.defaultPic,
            list: this.classData.list,
          },
        }).then((res: ItemObject) => {
          this.$message.success('保存成功');
        });
      } else {
        this.$nextTick(() => {
          if (this.$el.querySelector('.is-error')) {
            this.$el.querySelector('.is-error').scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
      }
    });
  }

  public handleAvatarSuccess() {
    const result = [...arguments];

    const index = result[2];
    const cIndex = result[3];

    if (index != undefined) {
      if (cIndex != undefined) {
        this.classSizeInfo[index].imageUrl[cIndex] = result[0].content;

        this.classSizeInfo[index].imageUrl.splice(cIndex, 1, result[0].content);
      } else {
        this.classSizeInfo[index].imageUrl.push(result[0].content);
      }
      this.classSizeInfo[index] = Object.assign({}, this.classSizeInfo[index], {
        imageUrl: this.classSizeInfo[index].imageUrl,
      });
      this.classSizeInfo.splice(index, 1, this.classSizeInfo[index]);
    }
  }

  handleSitePicSuccess(res, index = -1) {
    if (this.siteClassData.siteSizeTable[index]) {
      this.siteClassData.siteSizeTable[index].classSizePic = res.content;
    } else {
      this.siteClassData.siteSizePic = res.content;
    }
  }

  handlePicSuccess(res, index = -1) {
    if (this.classData.list[index]) {
      this.classData.list[index].classSizePic = res.content;
    } else {
      this.classData.defaultPic = res.content;
    }
  }

  public beforeAvatarUpload(file) {
    const isJpg = file.type === 'image/jpeg';
    const isPng = file.type === 'image/png';
    const isGif = file.type === 'image/gif';
    const LtSize = file.size / 1024 <= 2048;
    if (!isJpg && !isPng && !isGif) {
      this.$message.error('上传图片只能是 JPG/JPEG/PNG/GIF 格式!');
    }
    if (!LtSize) {
      this.$message.error('上传图片大小不能超过 2M!');
    }
    return (isJpg || isPng || isGif) && LtSize;
  }

  public deleteItem(i, c) {
    this.classSizeInfo[i].imageUrl.splice(c, 1);
  }

  /**
   * 添加尺码对照表
   * @param index
   * @return null
   */
  public onAdd(index = -1) {
    let selected = [];
    if (this.siteClassData.siteSizeTable[index]) {
      selected = this.siteClassData.siteSizeTable[index].classIds;
    }
    ChooseGoodsClass.open({ siteId: +this.$route.params.siteId, selected }).then((result) => {
      if (this.siteClassData.siteSizeTable[index]) {
        this.siteClassData.siteSizeTable[index].classIds = result;
      } else {
        this.siteClassData.siteSizeTable.push({
          classIds: result,
          classSizePic: '',
        });
      }
    }, noop);
  }

  /**
   * 添加尺码对照表
   * @param index
   * @return null
   */
  public onAddClassSize(index = -1) {
    const defaultCheckedKeys = index === -1 ? [] : this.classData.list[index].valueCodes;
    bindClassDialog.open({ defaultCheckedKeys }).then((result) => {
      const attrCodes: string[] = uniq(result.map(v => v.class_code));
      if (index === -1) {
        this.classData.list.push({
          valueCodes: result.filter(v => v.isLeafe).map(val => val.value_no),
          classSizePic: '',
          attrCodes,
        });
      } else {
        this.classData.list[index].valueCodes = result.filter(v => v.isLeafe).map(val => val.value_no);
        this.classData.list[index].attrCodes = attrCodes;
      }
    }, noop);
  }

  computedTree(list = [], result = []) {
    list.forEach((v) => {
      const item = {
        class_code: '',
        class_name: '',
        value_no: '',
        value_name: '',
      };
      item.class_code = v.attrCode || v.class_code;
      item.class_name = v.attrCode ? v.attrName : this.attributeListStore.find(v => v.attrCode === item.class_code).attrName;
      item.value_no = v.attrCode || v.value_no;
      item.value_name = v.attrName || v.value_name;
      result.push(item);
      if (v.list && v.list.length) {
        this.computedTree(v.list, result);
      }
    });
    return result;
  }

  /**
   * 计算分类名称
   */
  public computedName(codes = []) {
    const lacssList = [];
    const result = [];
    this.attributeListStore.forEach((i) => {
      if (codes.includes(i.value_no)) {
        lacssList.push(i);
      }
    });
    const groupClassList = groupBy(lacssList, 'class_code');
    Object.keys(groupClassList).forEach((v) => {
      const item = {
        class_code: v,
        class_name: '',
        value_no: [],
        value_name: [],
      };
      item.class_name = groupClassList[v][0].class_name;
      item.value_no = groupClassList[v].map(g => g.value_no);
      item.value_name = groupClassList[v].map(g => g.value_name);
      result.push(item);
    });
    return result.map(v => `${v.class_name}/${v.value_name.join('、')}`).join(',');
  }

  /**
   * 获取网点尺码对照表
   */
  public getSiteSizeTable() {
    IPSService.sitePicInfo({
      postParams: {
        siteId: +this.$route.params.siteId,
      },
    }).then((response) => {
      this.siteClassData.siteSizeTable = response.list;
      this.siteClassData.siteSizePic = response.siteSizePic;
    });
  }

  /**
   * 删除分类
   * @param index
   */
  handleDel(index: number) {
    this.$confirm('确认删除该分类?', { type: 'warning' }).then((result) => {
      if (result === 'confirm') {
        this.siteClassData.siteSizeTable.splice(index, 1);
      }
    }, noop);
  }

  /**
   * 删除分类
   * @param index
   */
  handleClassDel(index: number) {
    this.$confirm('确认删除该分类?', { type: 'warning' }).then((result) => {
      if (result === 'confirm') {
        this.classData.list.splice(index, 1);
      }
    }, noop);
  }

  /**
   * 获取网点分类列表
   */
  public getSiteClassList() {
    return IPSService.siteClassList({
      postParams: {
        siteId: +this.$route.params.siteId,
      },
    }).then((response) => {
      return response.list;
    });
  }
}
